export default __webpack_public_path__ + "static/media/756.6ad62189.jpg";